var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUnlink = function SvgUnlink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "m10.614 7.244 3.29-3.251a3.484 3.484 0 0 1 4.872 0l1.218 1.204a3.39 3.39 0 0 1 0 4.817l-3.289 3.251M13.384 16.757l-3.289 3.251a3.485 3.485 0 0 1-4.873 0l-1.218-1.204a3.39 3.39 0 0 1 0-4.817l3.29-3.251M8.953 15.07l1.904-1.881",
    className: "stroke-icon-main"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "m15.044 9.05-1.523 1.505-.38.376",
    className: "stroke-icon-main"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#71717A",
    strokeLinecap: "round",
    d: "m4 4 16 16"
  })));
};
export default SvgUnlink;